import { useEffect, useRef } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { useReducedMotion } from 'framer-motion';
//
import { PRODUCTS } from '../../data/products';
import Approach from '../../sections/home/Approach';
import Closing from '../../sections/home/Closing';
import Hero from '../../sections/home/hero/Hero';
import PageShell from '../../sections/home/PageShell';
import Products from '../../sections/home/products/Products';
import { HEAD } from '../../sections/home/copy';
import { focusTarget } from '../../sections/home/focus';

// ----------------------------------------------------------------------

function useHashScroll() {
  const { pathname, search, hash, key } = useLocation();

  const navigationType = useNavigationType();

  const navigate = useNavigate();

  const reduced = useReducedMotion();

  const landed = useRef(false);

  useEffect(() => {
    const arriving = !landed.current;
    landed.current = true;
    const target = hash && document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target || (navigationType === 'POP' && key !== 'default')) {
      return undefined;
    }
    const frame = requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: arriving || reduced ? 'auto' : 'smooth' });
      focusTarget(target);
      navigate({ pathname, search }, { replace: true });
    });
    return () => cancelAnimationFrame(frame);
  }, [pathname, search, hash, key, navigationType, navigate, reduced]);
}

export default function HomePage() {
  useHashScroll();

  return (
    <PageShell head={HEAD}>
      <Hero />
      <Products products={PRODUCTS} />
      <Approach />
      <Closing products={PRODUCTS} />
    </PageShell>
  );
}
